/**
 * What the damage numbers surface reports (P2.1-T4), through the game report's `damageNumbers`: how many numbers
 * show and have been made, how many hits have become numbers and been dropped, and, on request only, every number
 * showing.
 */

/**
 * One number as a browser suite reads it.
 */
export interface NumberReading {
  readonly target: number;
  readonly text: string;
  readonly taken: boolean;
  readonly tint: number;
  readonly x: number;
  readonly y: number;
  readonly inUiLayer: boolean;
  /** Whether it is hidden because the entity it stands over is concealed from the viewer (P1.9-T73). */
  readonly hidden: boolean;
}

/**
 * The surface's report.
 */
export interface DamageNumberReport {
  active: number;
  created: number;
  spawned: number;
  unplaced: number;
  taken: number;
  dealt: number;
  list: () => readonly NumberReading[];
}

/**
 * A report before the surface mounts.
 *
 * @returns The report.
 */
export function createDamageNumberReport(): DamageNumberReport {
  return { active: 0, created: 0, spawned: 0, unplaced: 0, taken: 0, dealt: 0, list: () => [] };
}
